import { Pipe, PipeTransform } from '@angular/core';
import { MoneyFormatService } from './money-format.service';

@Pipe({
    name: 'moneyFormat'
})
export class MoneyFormatPipe implements PipeTransform {

    constructor(private moneyFormatService: MoneyFormatService) { }

    transform(value: string | number | null | undefined, minimumFractionDigits: number = 2, maximumFractionDigits: number = 2): string {
        return this.moneyFormatService.format(value, minimumFractionDigits, maximumFractionDigits);
    }
}
